import { useEffect } from 'react'
import OtpInput from 'react-otp-input'


import { cn } from '@shared/lib/cn'
import Input, { InputProps } from '@shared/ui/input'

import styles from './styles.module.scss'


interface InputOtpProps {
  numInputs?: number;
  hasError?: boolean;
  value: string;
  autoSubmit?: boolean;
  onChange: (val: string) => void;
  onSubmit?: () => void;
}

export default function InputOTP (props: InputOtpProps) {
  const { hasError = false, numInputs = 4, value, onChange, onSubmit, autoSubmit } = props

  useEffect(() => {
    if (autoSubmit && value.length === numInputs && onSubmit) {
      onSubmit()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ value ])

  return (
    <div className={styles.root}>
      <OtpInput
        value={value}
        onChange={onChange}
        numInputs={numInputs}
        renderInput={(props) => (
          <div className={styles.inputCol}>
            <Input
              {...(props as InputProps)}
              inputClassName={cn(styles.otp, {
                [styles.hasError]: hasError,
              })}
              hideClearButton
              hideErrorIcon
              isInvalid={hasError}
              inputMode="numeric"
              name='sms'
              autoComplete='one-time-code'
            />
          </div>
        )}
      />
    </div>
  )
}
